import React, { Component } from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { breadcrumbs } from "../../../../actions/appActions";
import loginInfo from "../../components/LoginInfo";
import AuditHistoryView from "../../components/AuditHistoryView";
import OfficialHistoryDetailGrid from "../../components/grids/OfficialHistoryDetailGrid";
import { REQUEST_HISTORY_ENTITIES, REQUEST_HISTORY_ACTIONS } from "../../components/audit/entityLabels";
import Button from "../../../../components/form/Button";
import { styles } from "../../index";

class RequestHistoryPage extends Component {
  componentWillMount() {
    const { auth } = this.props;
    this.props.breadcrumbs([
      { label: "Žádosti", path: `${auth.startUrl}/zadosti` },
      { label: "Historie" },
    ]);
  }

  render() {
    const { auth, params } = this.props;
    return (
      <div>
        <AuditHistoryView
          auth={auth}
          grid={OfficialHistoryDetailGrid}
          gridName="requestHistoryGridV2"
          url={`${auth.startUrl}/api/zadosti/${params.id}/historie`}
          allowedEntityTypes={REQUEST_HISTORY_ENTITIES}
          allowedActions={REQUEST_HISTORY_ACTIONS}
        />
        <div style={{ marginTop: 12 }}>
          <Button
            type="button"
            style={styles.buttons}
            label="Zpět"
            onClick={() => this.props.goBack()}
          />
        </div>
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, goBack })(loginInfo(RequestHistoryPage));
